import React, { useState, useCallback, useEffect } from 'react';
import EvaLiveChat from './EvaLiveChat.jsx';
import SkipButton from './SkipButton.jsx';
import ConfirmationDialog from '../common/ConfirmationDialog.js';
import './intro.css';

/** QNA → DONE (greeting handled in EvaLiveChat) */
const IntroController = ({ onFinish, onHideIntro }) => {
  const [phase, setPhase] = useState('QNA');
  const [showHideIntroModal, setShowHideIntroModal] = useState(false);

  const advance = useCallback(() => {
    setPhase('DONE');
  }, []);

  useEffect(() => {
    if (phase === 'DONE') onFinish();
  }, [phase, onFinish]);

  const handleSkipClick = () => {
    setShowHideIntroModal(true);
  };

  const handleHideIntroConfirm = async () => {
    setShowHideIntroModal(false);
    if (onHideIntro) {
      await onHideIntro();
    }
    setPhase('DONE');
  };

  const handleHideIntroCancel = () => {
    setShowHideIntroModal(false);
    setPhase('DONE');
  };

  return (
    <div className="intro-wrapper">
      {phase !== 'DONE' && <SkipButton onSkip={handleSkipClick} />}
      {phase === 'QNA' && (
        <EvaLiveChat maxTurns={32} idleTimeoutMs={90_000} onComplete={advance} />
      )}
      
      <ConfirmationDialog
        visible={showHideIntroModal}
        title="Skip Intro Next Time?"
        message="You can turn it back on in the Settings."
        confirmText="Yes"
        cancelText="No"
        onConfirm={handleHideIntroConfirm}
        onCancel={handleHideIntroCancel}
      />
    </div>
  );
};

export default IntroController;